'use strict';

var transformDateTimePartNumberToStringWithZeroPadding = require('../common/transformDateTimePartNumberToStringWithZeroPadding.cjs');

const assemblePartsToISODatePartWithoutDay = (dateParts) => {
  return [
    transformDateTimePartNumberToStringWithZeroPadding(dateParts.year, 4),
    transformDateTimePartNumberToStringWithZeroPadding(dateParts.month)
  ].join("-");
};

module.exports = assemblePartsToISODatePartWithoutDay;
//# sourceMappingURL=assemblePartsToISODatePartWithoutDay.cjs.map
